import script from "./TransactionDetailInstantLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetailInstantLink.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetailInstantLink.vue?vue&type=style&index=0&id=af0e7f56&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af0e7f56"]])

export default __exports__